import React, { useContext } from "react";
import { PartnerContext } from "../PartnerOutlet";
import { Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "../partnerDashboard.module.css";

export default function PartnerNavigation() {
  const partnerContext = useContext(PartnerContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Helper function to determine if a route is active
  const isActiveRoute = (path) => location.pathname + location.search === path;

  // Common Button Component to reduce redundancy
  const RenderButton = ({ to, label }) => {
    return (
      <Button
        className={styles["partner-menu-btn"]}
        type={isActiveRoute(to) ? "primary" : "default"}
        onClick={() => navigate(to)}
      >
        {label}
      </Button>
    );
  };

  return (
    <div className="d-flex gap-2 flex-column flex-md-row">
      {partnerContext?.viewMode === "INVESTOR" ? (
        <>
          <RenderButton to="/partnerDashboard" label="Dashboard" />
          <RenderButton
            to="/partnerDashboard?view=recommend-policy"
            label="Recommend Policy"
          />
          <RenderButton
            to="/partnerDashboard?view=referred-portfolio"
            label="Referred Portfolio"
          />
          <RenderButton
            to="/partnerDashboard?view=track-assignment"
            label="Track Assignment"
          />
          <RenderButton
            to="/partnerDashboard?view=referred-user"
            label="My Investors"
          />
        </>
      ) : (
        <>
          <RenderButton to="/partnerDashboard" label="Dashboard - PH" />
          <RenderButton to="?view=referred-user" label="My Policy Holders" />
        </>
      )}
    </div>
  );
}
